var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-btn",style:(_vm.style),on:{"click":function($event){return _vm.onClick()}}},[(!_vm.loading)?_vm._t("default"):_c('i',{staticClass:"fa fa-spinner fa-spin"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }